import { lazy } from 'react';
import modules from '@src/service/modules';

const State = lazy(() => import('../../views/Location/State/index'));
const District = lazy(() => import('../../views/Location/District/index'));
const Taluka = lazy(() => import('../../views/Location/Taluka/index'));
const City = lazy(() => import('../../views/Location/City/index'));

const LocationRoutes = [
    {
        path: '/location/state',
        element: <State />
        // dbId: modules.setup_user
    },
    {
        path: '/location/district',
        element: <District />
        // dbId: modules.setup_user
    },
    {
        path: '/location/taluka',
        element: <Taluka />
        // dbId: modules.setup_user
    },
    {
        path: '/location/city',
        element: <City />
        // dbId: modules.setup_user    //
    }
];

export default LocationRoutes;
